/* Mobile controls use native events so unrelated theme errors cannot disable them. */
(function () {
  'use strict';
  const mobile = window.matchMedia('(max-width: 767px)');
  let opener = null;
  function drawer(open) {
    const menu = document.querySelector('.mobile-nav-wrapper');
    if (!menu) return;
    menu.classList.toggle('active', open);
    document.body.classList.toggle('menuOn', open);
    document.body.style.overflow = open ? 'hidden' : '';
    document.querySelectorAll('.js-mobile-nav-toggle').forEach(function (button) {
      button.classList.toggle('open', !open);
      button.classList.toggle('close', open);
      button.setAttribute('aria-expanded', String(open));
    });
    if (!open && opener) opener.focus();
  }
  function togglePanel(panel, control) {
    const open = getComputedStyle(panel).display === 'none' || panel.hidden;
    panel.hidden = !open;
    panel.style.setProperty('display', open ? 'block' : 'none', 'important');
    control.classList.toggle('active', open);
    control.setAttribute('aria-expanded', String(open));
  }
  function consume(event) { event.preventDefault(); event.stopImmediatePropagation(); }
  document.addEventListener('click', function (event) {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const toggle = target.closest('.js-mobile-nav-toggle');
    if (toggle) {
      consume(event); opener = toggle;
      const menu = document.querySelector('.mobile-nav-wrapper');
      drawer(!!menu && !menu.classList.contains('active')); return;
    }
    if (target.closest('.closemmn')) { consume(event); drawer(false); return; }
    const plus = target.closest('#MobileNav .at');
    if (plus) {
      const anchor = plus.closest('a');
      const panel = anchor && anchor.nextElementSibling;
      if (panel && panel.tagName === 'UL') {
        consume(event); togglePanel(panel, anchor);
        const open = anchor.getAttribute('aria-expanded') === 'true';
        plus.classList.toggle('at-plus-l', !open); plus.classList.toggle('at-minus-l', open);
        return;
      }
    }
    if (mobile.matches) {
      const heading = target.closest('.footer-links:not(.no-expand) .h4');
      if (heading && heading.nextElementSibling) {
        consume(event); togglePanel(heading.nextElementSibling, heading); return;
      }
      const title = target.closest('.acor-ttl');
      if (title) {
        const link = title.querySelector('a[href^="#"]');
        const panel = link && document.getElementById(link.hash.slice(1));
        if (panel) { consume(event); togglePanel(panel, link); return; }
      }
    }
    const menu = document.querySelector('.mobile-nav-wrapper.active');
    if (menu && !menu.contains(target)) drawer(false);
  }, true);
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') drawer(false);
    if (mobile.matches && (event.key === 'Enter' || event.key === ' ')) {
      const heading = event.target.closest('.footer-links:not(.no-expand) .h4');
      if (heading) { event.preventDefault(); heading.click(); }
    }
  });
  function prepare() {
    document.querySelectorAll('.footer-links:not(.no-expand) .h4').forEach(function (heading) {
      heading.setAttribute('role', 'button'); heading.tabIndex = 0;
    });
  }
  document.addEventListener('shopify:section:load', prepare);
  prepare();
  mobile.addEventListener('change', function () {
    drawer(false);
    document.querySelectorAll('.footer-links > ul, #MobileNav li > ul').forEach(function (panel) {
      panel.style.removeProperty('display'); panel.hidden = false;
    });
  });
})();
